import React, { useState } from "react";
import moment from "moment";

const LogsInfo = ({ data }) => {
  const [queryFlag, setQueryFlag] = useState(false);

  return (
    <div className="bg-[#FFF] dark:bg-[#0F0F0F] px-4 py-3 rounded-xl flex flex-col gap-4">
      {/* Log Created Time */}
      <div className="flex justify-between items-center flex-wrap">
        <p className="dark:text-white truncate xs:w-[120px]">{moment(data?.created_at).format("MMMM Do YYYY, h:mm A")}</p>
        <button
          onClick={() => setQueryFlag(!queryFlag)}
          className="bg-secondary text-black font-InterBold py-2 text-[16px] font-semibold rounded-full px-4"
        >
          {!queryFlag ? "All Detail" : "Close"}
        </button>
      </div>

      {/* Log Details */}
      {queryFlag && data?.log_details && data.log_details.length > 0 && (
        <div className="grid grid-cols-1 gap-3">
          {data.log_details.map((item, index) => (
            <div className="col-span-1 bg-[#F7F6F9] dark:bg-[#000] rounded-xl p-3" key={index}>
              <div className="flex items-center justify-between">
                <p className="text-primary font-InterBold font-semibold">{`#${index + 1}`}</p>
                <p className="dark:text-white font-Inter truncate xs:w-[120px]">{moment(item?.created_at).format("MMMM Do YYYY, h:mm A")}</p>
              </div>
              <p className="dark:text-white">
                <span className="text-primary">Query:</span>
                {` ${item?.user_query}`}
              </p>
              <p className="dark:text-white font-Inter">
                <span className="text-primary">Task Status:</span>
                {` ${item?.task_status}`}
              </p>
              <p className="dark:text-white font-Inter">
                <span className="text-primary">Execution Time:</span>
                {` ${item?.execution_time}`}
              </p>
              <p className="dark:text-white font-Inter">
                <span className="text-primary">No of subtask:</span>
                {` ${item?.no_of_subtasks}`}
              </p>
              <div className="dark:text-white font-Inter">
                <span className="text-primary">Logs Details:</span>
                <div>
                  {item?.log_details
                    ?.split("\n") // Split lines based on newline
                    .map((log, index) => (
                      <p key={index}>
                        {log.trim()} {/* Trim removes unnecessary spaces */}
                      </p>
                    ))}
                </div>
              </div>


            </div>
          ))}
        </div>
      )}

      {/* No Log Details */}
      {queryFlag && (!data?.log_details || data.log_details.length === 0) && (
        <p className="text-gray-400">No details available.</p>
      )}
    </div>
  );
};

export default LogsInfo;
